var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAboutLine2Mobile = function SvgAboutLine2Mobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 57 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.969 1s1.999 40.95-25.985 42.3C2 44.65 1 73 1 73",
    stroke: "#B0E9E9",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    strokeDasharray: "8 6"
  })));
};

export { SvgAboutLine2Mobile as ReactComponent };
export default __webpack_public_path__ + "static/media/about-line-2.mobile.d74fc04e.svg";